export const BarcodeBookState = {
  Initial: 0,
  Returned: 1,
  Reported: 2,
  Keeped: 3,
};

export const getStateName = (state) => {
  return (
    Object.keys(BarcodeBookState).find(
      (key) => BarcodeBookState[key] === state
    ) || null
  );
};
